<div class="loadingBox" *ngIf="!loaded">
    <img class="pulsate" src="assets/img/hostbrand/core-whitelogo.svg" width="300">
    <h3 *ngIf="!failed" i18n="@@Confirming Sub check phone | Confirming Sub check phone" class="subLoading pulsate" >Confirming Subscription. Check your phone for details</h3>
    <h3 *ngIf="failed" i18n="@@Unable to confirm sub | Unable to confirm sub message" class="subLoadingSmall">Unable to confirm your subscription. Please try again later or contact support@videyo.tv for help.</h3>
</div>
<div *ngIf="loaded">
    <div class="container-fluid mt-2">
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-4 p-5 offset-md-4 mt-2">
                        <span *ngIf="!subSite">
                            <div class="channels-card">
                                <div class="channels-card-image">
                                    <img class="img-fluid subImageSmall" src="assets/img/videyo-holding.jpg" alt="{{channel.name}}">
                                    <div class="channels-card-image-btn">
                                    </div>
                                </div>
                                <div class="channels-card-body">
                                    <div class="channels-title sitesub">
                                        <h2>
                                            <span i18n="@@Subscribe to | Subscribe to Label">Subscribe to</span> {{siteName}} <br/>via {{agent}} payment </h2>
                                        <h3 i18n="@@What will I be charged? | What will I be charged Label">What will I be charged?</h3>
                                        <p>
                                            <span i18n="@@You will be charged: | You will be charged Label">You will be charged:</span> {{currencySign}}{{cost}} {{siteRenew}}</p>
                                        <a href="javascript:;" (click)="subscribeSite()" i18n="@@Subscribe Now | Subscribe Now Label" class="unsubbutton white-outline-button subButton">Subscribe Now</a>
                                        <br/>
                                        <a href="/" class="unsubbutton white-outline-button" i18n="@@Oh No, Take me home! | Oh No, Take me home! Message">Oh no, Take me home!</a><br/><br/>
                                    </div>
                                </div>
                            </div>
                        </span>
                        <span *ngIf="subSite && !ozowDataBool">
                            <div class="channels-card">
                                <div class="channels-card-image">
                                    <img class="img-fluid" src="assets/img/videyo-holding.jpg" alt="{{channel.name}}">
                                    <div class="channels-card-image-btn">
                                    </div>
                                </div>
                                <div class="channels-card-body">
                                    <div class="channels-title sitesub">
                                        <h2 i18n="@@You are already subscribed to this Site | You are already subscribed to this Site Message">You are already subscribed to this Site</h2>
                                    </div>
                                    <a i18n="@@oh Yes, Take me home! | oh Yes, Take me home Message" href="/" class="unsubbutton white-outline-button">oh Yes, Take me home!</a>
                                </div>
                            </div>
                        </span>
                        <span *ngIf="ozowDataBool">
                            <div class="channels-card">
                                <div class="channels-card-image">
                                    <img class="img-fluid" src="assets/img/videyo-holding.jpg" alt="{{channel.name}}">
                                    <div class="channels-card-image-btn">
                                        <h2 i18n="@@Subscribe via Ozow EFT | Subscribe via Ozow EFT Message">Subscribe via Ozow EFT</h2>
                                    </div>
                                </div>
                                <div class="channels-card-body">
                                    <div class="channels-title sitesub">
                                        <form #form action="https://pay.ozow.com" method="post" accept-charset="utf-8" id="25EFT">
                                            <input type="hidden" name="SiteCode" value="{{ozowData.parameters.SiteCode}}">
                                            <input type="hidden" name="CountryCode" value="{{ozowData.parameters.CountryCode}}">
                                            <input type="hidden" name="CurrencyCode" value="{{ozowData.parameters.CurrencyCode}}">
                                            <input type="hidden" name="Amount" value="{{ozowData.parameters.Amount}}">

                                            <!-- reference on our bank statement. Suggest competition name + number votes -->
                                            <input type="hidden" name="TransactionReference" id="TransactionReference" value="{{ozowData.parameters.TransactionReference}}">

                                            <!-- reference on the voters bank statement. Suggest competition name + number votes -->
                                            <input type="hidden" name="BankReference" value="{{ozowData.parameters.BankReference}}">

                                            <!-- saving this in the optional field as it'll be saved with the transaction. NOTE, this is required -->
                                            <input type="hidden" name="Optional1" value="{{ozowData.parameters.Optional1}}">
                                            <!-- <input type="hidden" name="Optional2" value="{{ozowData.parameters.Optional2}}">
                                            <input type="hidden" name="Optional3" value="{{ozowData.parameters.Optional3}}">
                                            <input type="hidden" name="Optional4" value="{{ozowData.parameters.Optional4}}">
                                            <input type="hidden" name="Optional5" value="{{ozowData.parameters.Optional5}}"> -->

                                            <!-- TODO: JAMES, you'll need to update these urls to the pages on the front-end... -->
                                            <input type="hidden" name="CancelUrl" value="{{ozowData.parameters.CancelUrl}}">
                                            <input type="hidden" name="ErrorUrl" value="{{ozowData.parameters.ErrorUrl}}">
                                            <input type="hidden" name="SuccessUrl" value="{{ozowData.parameters.SuccessUrl}}">
                                            <input type="hidden" name="NotifyUrl" value="{{ozowData.parameters.NotifyUrl}}">

                                            <!-- if true, then allows for testing but doesn't report back to DB on their side -->
                                            <input type="hidden" name="IsTest" value="{{ozowData.parameters.IsTest}}">
                                            <!-- the output of the doHash is placed in here -->
                                            <input type="hidden" name="HashCheck" value="{{ozowData.hashString}}">
                                            <!-- normal form submit -->
                                            <p>
                                                <button type="submit" class="btn btn-success" (click)="form.submit()">Pay Now</button>
                                            </p>

                                        </form>
                                    </div>
                                </div>
</div>
                        </span>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>